<div id="date-preset-selector" class="date-preset-selector">
  <app-button
    *ngFor="let preset of presets"
    variant="none"
    type="button"
    [classes]="'preset-chip' + (isSelected(preset.value) ? ' active' : '')"
    [id]="'date-preset-' + preset.value"
    (click)="onPresetClick(preset.value)"
    [attr.aria-pressed]="isSelected(preset.value)"
    [attr.aria-label]="preset.labelKey | translate"
  >
    {{ preset.labelKey | translate }}
  </app-button>
</div>
